module.exports = __webpack_public_path__ + "static/media/myenroll.dcb001a7.svg";